import api from '@/api';

const state = {
  projects: [],
  projectsNextToken: null,
  projectsStatusFilter: null,
  currentProject: null,
  applications: [],
  currentApplication: null,
};

const getters = {
  projects: (state) => state.projects,
  projectsNextToken: (state) => state.projectsNextToken,
  projectsStatusFilter: (state) => state.projectsStatusFilter,
  currentProject: (state) => state.currentProject,
  applications: (state) => state.applications,
  currentApplication: (state) => state.currentApplication,
};

const actions = {
  async fetchProjects({ commit, state }) {
    try {
      const params = {};
      if (state.projectsNextToken) params.next_token = state.projectsNextToken;
      if (state.projectsStatusFilter)
        params.status = state.projectsStatusFilter;
      const response = await api.getProjects(params);
      commit('appendProjects', {
        projects: response.body.data,
        nextToken: response.body.next_token,
      });
      return { data: response.body };
    } catch (error) {
      return { error };
    }
  },
  async fetchProject({ commit }, id) {
    try {
      const response = await api.getProject(id);
      commit('setCurrentProject', response.body.data);
      return { data: response.body.data };
    } catch (error) {
      return { error };
    }
  },
  async acceptProject({ commit }, id) {
    try {
      const response = await api.acceptProject(id);
      commit('setCurrentProject', response.body.data);
      return { data: response.body.data };
    } catch (error) {
      return { error };
    }
  },
  async rejectProject({ commit }, id) {
    try {
      const response = await api.rejectProject(id);
      commit('setCurrentProject', response.body.data);
      return { data: response.body.data };
    } catch (error) {
      return { error };
    }
  },
  async fetchApplications({ commit }, projectId) {
    try {
      const response = await api.getProjectApplications(projectId);
      commit('setApplications', response.body.data);
      return { data: response.body.data };
    } catch (error) {
      return { error };
    }
  },
  async fetchApplication({ commit }, id) {
    try {
      const response = await api.getApplication(id);
      commit('setCurrentApplication', response.body.data);
      return { data: response.body.data };
    } catch (error) {
      return { error };
    }
  },
  async acceptApplication({ commit }, id) {
    try {
      const response = await api.acceptApplication(id);
      commit('setCurrentApplication', response.body.data);
      return { data: response.body.data };
    } catch (error) {
      return { error };
    }
  },
  async rejectApplication({ commit }, id) {
    try {
      const response = await api.rejectApplication(id);
      commit('setCurrentApplication', response.body.data);
      return { data: response.body.data };
    } catch (error) {
      return { error };
    }
  },
};

const mutations = {
  appendProjects(state, { projects = [], nextToken }) {
    state.projects = state.projects.concat(projects);
    state.projectsNextToken = nextToken;
  },
  clearProjects(state) {
    state.projects = [];
    state.projectsNextToken = null;
  },
  setProjectsStatusFilter(state, status) {
    state.projectsStatusFilter = status;
  },
  setCurrentProject(state, project) {
    state.currentProject = project;
  },
  clearCurrentProject(state) {
    state.currentProject = null;
  },
  setApplications(state, applications) {
    state.applications = applications;
  },
  clearApplications(state) {
    state.applications = [];
  },
  setCurrentApplication(state, application) {
    state.currentApplication = application;
  },
  clearCurrentApplication(state) {
    state.currentApplication = null;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
